<template>
  <div :class="`activity ${type}-activity`">
    <div class="d-flex align-items-center activity__header">
      <filter-buttons
        :items="filterItems"
        :active="filterActive"
        :min-width="100"
        :loading="filterLoading"
        :show-title="false"
        class="flex-grow-1 mr-3"
        @change="setFilterActive"
      />
      <div class="px-3 ml-auto d-flex activity__audit">
        <span class="mr-2">
          Audit Mode
        </span>
        <toggle-button
          type="checkbox"
          v-model="auditMode"
          class="align-self-center"
          :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          :disabled="filterLoading"
        />
      </div>
    </div>
    <div class="activity__body">
      <activity-table
        :audit="audit"
        :type="type"
        :loading="filterLoading"
      />
      <pagination
        :data="pagination"
        :disabled="filterLoading"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import FilterButtons from '@/components/FilterButtons'
import ActivityTable from '@/components/ActivityTable'
import {createHttpQuery} from '@/helpers'
import Pagination from '@/components/Pagination'

const props = {
  data: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
}
export default {
  components: {
    FilterButtons,
    Pagination,
    ActivityTable,
    ToggleButton,
  },
  props: props,
  data () {
    return {
      page: 1,
      pagination: null,
      audit: [],
      searchQuery: '',
      allFilterItems: [
        {name: 'All', value: 'all', attr: 'all'},
        {name: 'Email', value: 'email', attr: 'email'},
        {name: 'Web', value: 'web', attr: 'web'},
        {name: 'Admin', value: 'admin', attr: 'admin'},
      ],
      filterLoading: false,
      filterActive: 'all',
      auditMode: false,
    }
  },
  computed: {
    filterItemsActive () {
      if (this.type === 'newsletter') {
        return ['all', 'email', 'admin']
      } else {
        return ['all', 'email', 'web', 'admin']
      }
    },
    filterItems () {
      return this.allFilterItems.filter((it) => this.filterItemsActive.includes(it.value))
    },
  },
  mounted () {
    this.getAudit()
  },
  watch: {
    data: {
      deep: true,
      handler (newData, oldData) {
        if (newData && newData.id !== null) {
          this.resetAudit()
          this.getAudit()
        }
      },
    },
    filterActive () {
      this.page = 1
      this.getAudit()
    },
    auditMode () {
      this.page = 1
      this.getAudit()
    },
  },
  methods: {
    async getAudit () {
      this.filterLoading = true
      const params = createHttpQuery({
        page: this.page,
        category_id: this.filterActive === 'all' ? '' : this.filterActive,
        audit_mode: this.auditMode,
      })
      const {data} = await this.$http.get(`/audits/${this.type}s/${this.data.id}`, {
        params,
      })
      this.audit = data.data
      this.pagination = data.meta
      this.filterLoading = false
    },
    resetAudit () {
      this.filterActive = 'all'
      this.auditMode = false
    },
    changePage (page) {
      this.page = page
      this.getAudit()
    },
    setFilterActive (filter) {
      this.filterActive = filter.toLowerCase()
    },
  },
}
</script>

<style lang="scss">
  .activity {
    &__header {
      .el-input {
        width: auto;
      }

      @media(max-width: 576px) {
        flex-direction: column;

        .filter-buttons-wrapper {
          width: 100%;
          margin: 0.5rem 0 !important;
        }

        .activity__audit {
          margin: 0.5rem 0;
        }
      }
    }

    .custom-border {
      border-width: 2px;
      border-style: solid;
      &__email {
        border-color: $email-border !important;
      }
      &__web {
        border-color: $web-border !important;
      }
      &__admin {
        border-color: $admin-border !important;
      }
      &__grey {
        border-color: grey;
      }
    }
  }


</style>
